/**
 * O algoritmo `TEG-SORTEIO-v1` em palavras (seção 2.3 do contrato da frente
 * F08). Um texto só, usado pela página pública ("Verifique você mesmo") e pela
 * ata em PDF da área interna — duas cópias divergiriam na primeira correção.
 *
 * O cálculo de verdade está em `verificacao.ts` (navegador) e no banco; aqui é
 * só a explicação para quem quer conferir.
 */

export const NOME_DO_ALGORITMO = 'TEG-SORTEIO-v1';

export const PASSOS_DO_ALGORITMO: readonly { titulo: string; texto: string }[] = [
  {
    titulo: 'Estrato',
    texto:
      'Cada DRE com cada modalidade forma um estrato, com vagas próprias. O sorteio acontece dentro de cada estrato, separadamente.',
  },
  {
    titulo: 'Linha de cada participante',
    texto:
      'Cada veículo elegível vira uma linha no formato código da DRE|modalidade|vagas do estrato|protocolo|nome, com o nome sem barra vertical nem quebra de linha e sem espaços nas pontas.',
  },
  {
    titulo: 'Universo',
    texto:
      'As linhas são ordenadas por código da DRE, modalidade e protocolo, em ordem de bytes, e cada uma recebe uma quebra de linha no fim. O SHA-256 desse texto inteiro é o hash do universo, registrado no preparo: a lista de participantes não pode mudar depois dele.',
  },
  {
    titulo: 'Semente e compromisso',
    texto:
      'No preparo, o sistema gera uma semente de 32 bytes aleatórios e registra só o SHA-256 dela (o compromisso). A semente fica guardada e só é revelada, em hexadecimal, na execução. Qualquer pessoa confere que a semente revelada é a mesma do compromisso calculando o SHA-256 dela.',
  },
  {
    titulo: 'Classificação',
    texto:
      'Dentro de cada estrato, os participantes são ordenados pelo HMAC-SHA256 do protocolo (em UTF-8), usando a semente como chave, do menor para o maior, comparando os bytes. Em caso de empate, vale a ordem do protocolo. As posições vão de 1 ao total do estrato.',
  },
  {
    titulo: 'Situação',
    texto:
      'Quem fica numa posição até o número de vagas do estrato é contemplado. Os demais são suplentes, na ordem: posição menos vagas é o número na lista de espera.',
  },
  {
    titulo: 'Hash do resultado',
    texto:
      'O resultado é escrito linha a linha como código da DRE|modalidade|posição|protocolo|situação, com quebra de linha, na ordem dos estratos e das posições. O SHA-256 desse texto é o hash do resultado.',
  },
  {
    titulo: 'Trilha encadeada',
    texto:
      'Cada ato (preparo, execução, tentativa recusada, publicação, chamada de suplente) vira um evento cujo hash é o SHA-256 de hash anterior|sequência|sorteio|tipo|autor|data e hora UTC|detalhe. O primeiro evento parte de 64 zeros. Alterar qualquer evento quebra todos os seguintes.',
  },
];

/**
 * Pendência D-05, dita sem rodeio. Aparece fixa no painel interno e na ata; a
 * página pública a repete dentro de "Verifique você mesmo".
 */
export const PENDENCIA_DA_SEMENTE =
  'A semente do sorteio é gerada pelo próprio sistema no preparo, e o compromisso (o hash dela) é registrado antes da execução. O vínculo com uma fonte pública externa de aleatoriedade, como a Loteria Federal, ainda não existe e está pendente de decisão.';

/** Script de conferência independente, no repositório do sistema. */
export const SCRIPT_DE_VERIFICACAO = 'ferramentas/verificar-sorteio.mjs';
